module.exports = __webpack_public_path__ + "img/me_1.bbf44917.jpg";